(function () {
    'use strict';

    var serviceId = 'spinner';

    angular.module('app.common').factory(serviceId, spinner);

    spinner.$inject = ['common'];

    function spinner(common) {
        var factory = {
            spinnerHide: spinnerHide,
            spinnerShow: spinnerShow
        };

        return factory;

        function spinnerHide() { spinnerToggle(false); }

        function spinnerShow() { spinnerToggle(true); }

        function spinnerToggle(show) {
            common.$broadcast(common.config.events.spinnerToggle, { show: show });
        }
    }
    
})();